import { atom } from "recoil";
import { Location } from 'react-router-dom';

export const LastLocationState = atom<Partial<Location>>({
  key: 'LastLocationState',
  default: {},
});
